import{a as o}from"./chunk-EMIEIAAH.js";import{a as t}from"./chunk-ENXBNJ36.js";function l(...n){return o(a,n)}function a(n,y){if(!t(n,2))return n[0];let[r]=n,[,...i]=n;for(let e of i)y(e,r)<0&&(r=e);return r}export{l as a};
